import { getChartColors } from '@/components/marketing/visualizations/nivoTheme'
import type { DashboardTrendPoint } from '@/types/dashboard-summary'

export interface TrendSeries {
  id: string
  color: string
  data: { x: string; y: number }[]
}

/** `2026-07-07T03` → `3:00`; `2026-07-07` → `07/07`. */
export function formatBucketLabel(bucket: string): string {
  if (bucket.includes('T')) {
    const hour = bucket.split('T')[1]
    return `${parseInt(hour, 10)}:00`
  }
  const parts = bucket.split('-')
  return parts.length === 3 ? `${parts[1]}/${parts[2]}` : bucket
}

/** Single Nivo series for conversation counts. Charted on its own axis so its
 *  10s–100s/day scale isn't swamped by revenue. */
export function toConversationSeries(points: DashboardTrendPoint[]): TrendSeries[] {
  return [
    {
      id: 'Conversations',
      color: getChartColors()[0],
      data: points.map((p) => ({ x: formatBucketLabel(p.bucket), y: p.conversations })),
    },
  ]
}

/** Single Nivo series for revenue (cents → currency units), charted on its own axis. */
export function toRevenueSeries(points: DashboardTrendPoint[]): TrendSeries[] {
  return [
    {
      id: 'Revenue',
      color: getChartColors()[3],
      data: points.map((p) => ({ x: formatBucketLabel(p.bucket), y: (p.revenueCents ?? 0) / 100 })),
    },
  ]
}
